import React, { useState, useEffect, useRef } from 'react';
import { Form, Tag, message, Cascader, DatePicker, Select } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import './partnerJobSort.css';
import PropTypes from 'prop-types';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import approveImg from '../../public/img/newMain/Approve.png';
import resetWhite from '../../public/img/newMain/resetWhite.png';

let PartnerJobSort = ({ onOpenChange, isReset }) => {
    const [form] = Form.useForm();
    const [selectedConditions, setSelectedConditions] = useState({});
    const [jobTypeList, setJobTypeList] = useState([]);
    const [positionTypeList, setPositionTypeList] = useState([]);
    const [workLocList, setWorkLocList] = useState([]);
    const [areaOptions, setAreaOptions] = useState([]);
    const [jobPostModel, setJobPostModel] = useState({});
    const jobPostModelRef = useRef({});
    const [sortOptions, setSortOptions] = useState([]);

    useEffect(() => {
        searchJobType();
        searchPositionType();
        searchWorkLoc();
        searchAllArea();
        setSortOptions([
            {
                label: "",
                value: ""
            },
            {
                label: "Job ID",
                value: "jobId"
            },
            {
                label: "Job Title",
                value: "jobTitle"
            },
            {
                label: "THEi Programme",
                value: "progTitle"
            },
            {
                label: "Job Mode",
                value: "positionType"
            },
            {
                label: "Commence Date",
                value: "expCommenceDate"
            },
            {
                label: "End Date",
                value: "expEndDate"
            },
            {
                label: "Application Deadline",
                value: "lastApplyDate"
            },
        ])
    }, []);

    useEffect(() => {
        if (isReset) {
            reset()
        }
    }, [isReset])

    const handleChange = (selectedOption) => {
        console.log(selectedOption);
        form.setFieldValue('sortBy', selectedOption)
    };

    const save = () => {
        form.validateFields().then(() => {
            selectedConditions['jobPostStatus'] ? jobPostModel.jobPostStatusList = selectedConditions['jobPostStatus'] : "";
            selectedConditions['jobType'] ? jobPostModel.jobTypeList = selectedConditions['jobType'] : "";
            selectedConditions['positionType'] ? jobPostModel.positionTypeList = selectedConditions['positionType'] : "";
            // jobPostModel.studentAppliedInputStart = form.getFieldValue('studentAppliedInputStart');
            // jobPostModel.studentAppliedInputEnd = form.getFieldValue('studentAppliedInputEnd');
            jobPostModel.commenceStartDate = form.getFieldValue('startDate');
            jobPostModel.commenceEndDate = form.getFieldValue('endDate');
            jobPostModel.appDeadStartDate = form.getFieldValue('appDeadStartDate');
            jobPostModel.appDeadEndDate = form.getFieldValue('appDeadEndDate');
            jobPostModel.sortBy = form.getFieldValue('sortBy');
            onOpenChange(false, true, jobPostModel)
        })
    }

    const reset = () => {
        setSelectedConditions({});
        form.resetFields()
        setJobPostModel({})
    }


    const close = () => {
        onOpenChange(false, false)
    }

    const onChangeAddressA = (value) => {
        setJobPostModel(model => {
            jobPostModelRef.current = { ...model, ...{ workLocIdList: value } };
            return { ...model, ...{ workLocIdList: value } };
        });
    }

    const searchJobType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "JOB_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setJobTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchPositionType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "POSITION_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setPositionTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchAllArea = () => {
        Base.callBackApi("commonDropDown/searchAllArea").then((data) => {
            if ("SUCCESS" === data.msg) {
                setAreaOptions(data?.object ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchWorkLoc = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "WORK_LOCATION" }).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setWorkLocList(list ?? []);
            } else {
                message.error(data?.msg);
            }
        }).catch(err => { });
    }

    const handleConditionClick = (condition, groupName) => {
        const updatedSelectedConditions = { ...selectedConditions };
        if (!updatedSelectedConditions[groupName]) {
            updatedSelectedConditions[groupName] = [];
        }

        const index = updatedSelectedConditions[groupName].indexOf(condition);
        if (index !== -1) {
            // 如果已选中，则移除
            updatedSelectedConditions[groupName].splice(index, 1);
        } else {
            // 如果未选中，则添加
            updatedSelectedConditions[groupName].push(condition);
        }

        setSelectedConditions(updatedSelectedConditions);
    };

    const isConditionSelected = (condition, groupName) => {
        if (selectedConditions[groupName]) {
            return selectedConditions[groupName].includes(condition);
        }
        return false;
    };

    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('endDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('startDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    const checkStartDate2 = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('appDeadEndDate')) && Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate2 = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('appDeadStartDate')) && Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    const studentAppliedInputStart = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('studentAppliedInputEnd')) && parseInt(form.getFieldValue('studentAppliedInputStart')) > parseInt(form.getFieldValue('studentAppliedInputEnd'))) {
            return Promise.reject("Start number cannot be later than end number.");
        }
        return Promise.resolve();
    }

    const studentAppliedInputEnd = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('studentAppliedInputStart')) && parseInt(form.getFieldValue('studentAppliedInputStart')) > parseInt(form.getFieldValue('studentAppliedInputEnd'))) {
            return Promise.reject("End number cannot be smaller than start number.")
        }
        return Promise.resolve();

    }


    return (
        <div className='partnerJobSort'>
            <Form form={form}>
                <div>
                    <div className='closePopover' onClick={close}><CloseCircleOutlined /></div>
                    <div className='Title'>
                        <span className='lable'>Job Post Status :</span>
                        <Tag className={isConditionSelected('DRAFT', 'jobPostStatus') ? 'selected' : 'noSelected'} onClick={() => handleConditionClick('DRAFT', 'jobPostStatus')}>Draft</Tag>
                        <Tag className={isConditionSelected('SUBMITTED', 'jobPostStatus') ? 'selected' : 'noSelected'} onClick={() => handleConditionClick('SUBMITTED', 'jobPostStatus')}>THEi Reviewing</Tag>
                        <Tag className={isConditionSelected('ACTIVE', 'jobPostStatus') ? 'selected' : 'noSelected'} onClick={() => handleConditionClick('ACTIVE', 'jobPostStatus')}>Active</Tag>
                    </div>
                    <div className='Title'>
                        <span className='lable'>Job Mode :</span>
                        {
                            positionTypeList?.map((item, index) =>
                                <Tag key={index} className={isConditionSelected(item.paramId, 'positionType') ? 'selected' : 'noSelected'}
                                    onClick={() => handleConditionClick(item.paramId, 'positionType')}>{item.parmValue1}</Tag>
                            )
                        }
                    </div>
                    <div className='Title'>
                        <span className='lable'>Employment Type :</span>
                        {
                            jobTypeList?.map((item, index) =>
                                <Tag key={index} className={isConditionSelected(item.paramId, 'jobType') ? 'selected' : 'noSelected'}
                                    onClick={() => handleConditionClick(item.paramId, 'jobType')}>{item.parmValue1}</Tag>
                            )
                        }
                    </div>
                    <div className='Title' style={{ marginBottom: '10px' }}>
                        <span className='lable'>Work Location :</span>
                        <span id="workLocIdList">
                            <Cascader
                                value={jobPostModel?.workLocIdList || []}
                                options={areaOptions}
                                onChange={onChangeAddressA}
                                changeOnSelect
                                placeholder=""
                                getPopupContainer={() => document.getElementById('workLocIdList')}
                            />
                        </span>
                    </div>
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Expected Date :</span>
                        <span style={{ display: 'flex' }}>
                            <div>
                                <Form.Item
                                    name="startDate"
                                    rules={[
                                        { validator: (rule, value) => checkStartDate(value) },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <div>
                                <Form.Item
                                    name="endDate"
                                    rules={[
                                        { validator: (rule, value) => checkEndDate(value) },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                        </span>
                    </div>
                    {/* <div className='Title' style={{ marginBottom: '10px' }}>
                        <div style={{ display: 'flex' }}>
                            <span className='lable'>Student Applied :</span>
                            <Form.Item
                                name="studentAppliedInputStart"
                                rules={[
                                    { validator: (rule, value) => studentAppliedInputStart(value) },
                                ]}
                            >
                                <Input className='studentAppliedInput' type="number"
                                    onInput={(e) => {
                                        let inputValue = e.target.value;
                                        inputValue = inputValue.replace(/[^\d]/g, '');
                                        if (parseInt(inputValue) < 0) {
                                            e.target.value = '';
                                        } else {
                                            e.target.value = inputValue;
                                        }
                                    }}
                                />
                            </Form.Item>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <Form.Item
                                name="studentAppliedInputEnd"
                                rules={[
                                    { validator: (rule, value) => studentAppliedInputEnd(value) },
                                ]}
                            >
                                <Input className='studentAppliedInput' type="number"
                                    onInput={(e) => {
                                        let inputValue = e.target.value;
                                        inputValue = inputValue.replace(/[^\d]/g, '');
                                        if (parseInt(inputValue) < 0) {
                                            e.target.value = '';
                                        } else {
                                            e.target.value = inputValue;
                                        }
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </div> */}
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Application Deadline :</span>
                        <span style={{ display: 'flex' }}>
                            <div>
                                <Form.Item
                                    name="appDeadStartDate"
                                    rules={[
                                        { validator: (rule, value) => checkStartDate2(value) },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            <span style={{ margin: '0px 10px' }}>-</span>
                            <div>
                                <Form.Item
                                    name="appDeadEndDate"
                                    rules={[
                                        { validator: (rule, value) => checkEndDate2(value) },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                        </span>
                    </div>
                    <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Sort By :</span>
                        <Form.Item
                            name="sortBy"
                        >
                            <Select
                                onChange={handleChange}
                                options={sortOptions}
                            />
                        </Form.Item>
                    </div>
                </div>
            </Form>
            <div className='butArea'>
                <div className='saveButton' type="primary" onClick={save}><img src={approveImg} />Confirm</div>
                <div className='resetButton' onClick={reset}><img src={resetWhite} />Reset</div>
            </div>
        </div>
    )

}
PartnerJobSort.propTypes = {
    onOpenChange: PropTypes.func.isRequired,
    isReset: PropTypes.bool.isRequired,
};
export default PartnerJobSort;